/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventOverviewController', DinghyEventOverviewController);

    DinghyEventOverviewController.$inject = ['$scope', '$rootScope', '$sce', 'entity', '$state', '$window', '$location', 'AlertService', 'Principal'];

    function DinghyEventOverviewController($scope, $rootScope, $sce, entity, $state, $window, $location, AlertService, Principal) {
        var vm = this;
        vm.goTo = goTo;

        vm.dinghyEvent = entity;
        vm.validPlaces = vm.dinghyEvent.bookedPlaces.countAngemeldet + vm.dinghyEvent.bookedPlaces.countWarteliste;
        vm.bookUrl =  $location.protocol() + "://" + location.host + "/" + $state.href("member.dinghy-events.book", {id: vm.dinghyEvent.id});

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });
        vm.isDinghy = false;
        Principal.hasAuthority('ROLE_DINGHY').then(function (result) {
            vm.isDinghy = result;
        });

        var clipboardBookUrl = new ClipboardJS(document.getElementById("copyUrlButton"));
        clipboardBookUrl.on('success', function(e) {
            $scope.$apply(function() {
                AlertService.success("Anmeldelink wurde in die Zwischenablage kopiert.");
            });
            e.clearSelection();
        });
        clipboardBookUrl.on('error', function(e) {
            $scope.$apply(function() {
                AlertService.error("Anmeldelink konnte nicht kopiert werden.");
            });
        });

        var unsubscribe = $rootScope.$on('askApp:dinghyEventUpdate', function(event, result) {
            vm.dinghyEvent = result;
            vm.validPlaces = vm.dinghyEvent.bookedPlaces.countAngemeldet + vm.dinghyEvent.bookedPlaces.countWarteliste;
        });

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        $scope.$on('$destroy', unsubscribe);

        function goTo(url) {
            $window.open(url, "_blank");
        }
    }
})();
